import React from 'react';
import styles from './pagination.module.scss';

interface PaginationProps {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null;

    return (
        <div className={styles.pagination}>
            <button 
                className={styles.pageBtn} 
                disabled={currentPage === 1} 
                onClick={() => onPageChange(Math.max(1, currentPage - 1))}
                aria-label="Previous page"
            >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                    <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z" />
                </svg>
            </button>
            <span className={styles.pageInfo}>{currentPage} of {totalPages}</span>
            <button 
                className={styles.pageBtn} 
                disabled={currentPage >= totalPages} 
                onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
                aria-label="Next page"
            >
                <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
                    <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
                </svg>
            </button>
        </div>
    );
};

export default Pagination;
